import type { PdpViewedEvent } from './PdpViewedEvent';
import { pdpViewedSchema } from './PdpViewedSchema';

type Props = {
  listingId: string | null;
};

export const pdpViewedToEvent = ({ listingId }: Props): PdpViewedEvent => {
  const event: PdpViewedEvent = {
    schema: pdpViewedSchema.ref,
    data: {
      listing_id: listingId,
    },
  };

  return event;
};
